import { render, staticRenderFns } from "./ElementsBlockPreview.vue?vue&type=template&id=76a6e1b0&scoped=true"
import script from "./ElementsBlockPreview.vue?vue&type=script&lang=js"
export * from "./ElementsBlockPreview.vue?vue&type=script&lang=js"
import style0 from "./ElementsBlockPreview.vue?vue&type=style&index=0&id=76a6e1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a6e1b0",
  null
  
)

export default component.exports